export default "__VITE_ASSET__BzID2qE3__"